import SalesOffice from './SalesOffice'
import Feature from './Feature'
export class Employee {
    ID: number;
    Username: string;
    // Password: string;
    FirstName: string;
    MiddleName?: string;
    LastName: string;
    FullName?: string;
    FullNameWithPersonnelNumber?: string;
    Suffix?: string;
    PersonnelNumber: string;
    PhoneNumber: string;
    EmailAddress: string;
    SalesOfficeID: number;
    SalesOffice: SalesOffice;
    Features?: Feature[];
    Inactive: boolean;
    IsSuper: boolean;
}

export default Employee;